import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { tutorStepPropTypes } from './step-component-props';
import { LearnMore } from './learn-more';
import { StyledTutorialStep } from './tutorial-steps';
import helpTrackingImage from '../../media/helpTracking.png';

export const AddTheTrackingCodeToYourWebsite = (props) => {
  const { i18n } = props;
  const text = i18n.getString(_TL_('Add the UET tag tracking code throughout your website, either directly or through your tag management solution.'));
  const content = (
    <p>
      <ReactTemplate template={text} />
      <LearnMore i18n={i18n} topicId="app51203" ariaLabel={text} />
    </p>
  );

  return (
    <StyledTutorialStep
      title={i18n.getString(_TL_('Add the tracking code to your website'))}
      imageSrc={helpTrackingImage}
      descTemp={content}
      i18n={i18n}
    />
  );
};

AddTheTrackingCodeToYourWebsite.propTypes = tutorStepPropTypes;
